import axios from 'axios';
import { getApiURL } from './utils';
import { INSIGHT_TIME_FILTERS, INSIGHT_TYPES } from './constants';

const instance = axios.create({
  // baseURL: 'http://localhost:9781',
  baseURL: getApiURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export const auth = (token) =>
  instance
    .post(
      `/web-app/auth`,
      {},
      {
        headers: {
          sessionId: token || localStorage.getItem('sessionId_clappy'),
        },
      }
    )
    .then(() => {
      if (token) {
        localStorage.setItem('sessionId_clappy', token);
      }
    });

export const getProfile = () =>
  instance
    .post(
      `/web-app/get-profile`,
      {},
      {
        headers: {
          sessionId: localStorage.getItem('sessionId_clappy'),
        },
      }
    )
    .then(({ data }) => data);

export const listRewards = () =>
  instance
    .post(
      `/web-app/rewards/list`,
      {},
      {
        headers: {
          sessionId: localStorage.getItem('sessionId_clappy'),
        },
      }
    )
    .then(({ data }) => data);

export const addReward = (params) =>
  instance
    .post(`/web-app/rewards/add`, params, {
      headers: {
        sessionId: localStorage.getItem('sessionId_clappy'),
      },
    })
    .then(({ data }) => data);

export const updateReward = (params) =>
  instance
    .post(`/web-app/rewards/update`, params, {
      headers: {
        sessionId: localStorage.getItem('sessionId_clappy'),
      },
    })
    .then(({ data }) => data);

export const claimReward = (params) =>
  instance
    .post(`/web-app/rewards/claim`, params, {
      headers: {
        sessionId: localStorage.getItem('sessionId_clappy'),
      },
    })
    .then(({ data }) => data);

export const getUserProfile = (params) =>
  instance
    .post(`/web-app/analytics/get-user-profile`, params, {
      headers: {
        sessionId: localStorage.getItem('sessionId_clappy'),
      },
    })
    .then(({ data }) => data);

export const getUserFeed = (params) =>
  instance
    .post(`/web-app/analytics/get-user-feed`, params, {
      headers: {
        sessionId: localStorage.getItem('sessionId_clappy'),
      },
    })
    .then(({ data }) => data);

export const fetchInsights = (
  pageGiver = 1,
  pageReceiver = 1,
  timeFilter = INSIGHT_TIME_FILTERS.ALL_TIME.id,
  fetchDepartmentData = false,
  departmentFilter = null
) => {
  const dates = {
    startDate:
      timeFilter === INSIGHT_TIME_FILTERS.LAST_30_DAYS.id
        ? new Date(new Date().setDate(new Date().getDate() - 30))
        : timeFilter === INSIGHT_TIME_FILTERS.LAST_3_MONTH.id
        ? new Date(new Date().setMonth(new Date().getMonth() - 3))
        : null,
    endDate:
      timeFilter === INSIGHT_TIME_FILTERS.LAST_30_DAYS.id
        ? new Date()
        : timeFilter === INSIGHT_TIME_FILTERS.LAST_3_MONTH.id
        ? new Date()
        : null,
  };
  return instance
    .post(
      `/web-app/analytics/fetch`,
      {
        ...(departmentFilter ? { departmentId: departmentFilter } : {}),
        items: [
          { type: INSIGHT_TYPES.ACTIVE_USERS_30D },
          {
            type: INSIGHT_TYPES.TOP_USER_PER_VALUE,
            ...(timeFilter && timeFilter !== INSIGHT_TIME_FILTERS.ALL_TIME.id
              ? dates
              : {}),
          },
          { type: INSIGHT_TYPES.CLAPS_EXCHANGED_ALL_TIME },
          { type: INSIGHT_TYPES.CLAPS_EXCHANGED_LAST_WEEKS },
          {
            type: INSIGHT_TYPES.USER_RANKING,
            ...(timeFilter && timeFilter !== INSIGHT_TIME_FILTERS.ALL_TIME.id
              ? dates
              : {}),
            params: {
              type: 'GIVER',
              from: (pageGiver - 1) * 10,
              to: pageGiver * 10,
            },
          },
          {
            type: INSIGHT_TYPES.USER_RANKING,
            ...(timeFilter && timeFilter !== INSIGHT_TIME_FILTERS.ALL_TIME.id
              ? dates
              : {}),
            params: {
              type: 'RECEIVER',
              from: (pageReceiver - 1) * 10,
              to: pageReceiver * 10,
            },
          },
          {
            type: INSIGHT_TYPES.VALUES_USAGE,
            ...(timeFilter && timeFilter !== INSIGHT_TIME_FILTERS.ALL_TIME.id
              ? dates
              : {}),
          },
          ...(fetchDepartmentData
            ? [
                {
                  type: INSIGHT_TYPES.DEPT_INSIGHTS,
                  ...(timeFilter &&
                  timeFilter !== INSIGHT_TIME_FILTERS.ALL_TIME.id
                    ? dates
                    : {}),
                },
              ]
            : []),
        ],
      },
      {
        headers: {
          sessionId: localStorage.getItem('sessionId_clappy'),
        },
      }
    )
    .then(({ data }) => data);
};

export const getLeaderboard = (params) =>
  instance
    .post(`/web-app/analytics/get-leaderboard`, params, {
      headers: {
        sessionId: localStorage.getItem('sessionId_clappy'),
      },
    })
    .then(({ data }) => data);

export const exportRecognitions = (params) =>
  instance.get(`/web-app/analytics/export-recognitions`, {
    headers: {
      sessionId: localStorage.getItem('sessionId_clappy'),
    },
    params: { ...params },
    responseType: 'blob',
  });

// router.post('/delete-shout-out', CheckAdmin, [
//   body('shoutOutId').isMongoId(),
//   body('cascade').isBoolean().optional(),

export const deleteRecognition = (params) =>
  instance
    .post(`/web-app/delete-shout-out`, params, {
      headers: {
        sessionId: localStorage.getItem('sessionId_clappy'),
      },
    })
    .then(({ data }) => data);

//get-departments
export const getDepartments = () =>
  instance
    .post(`/web-app/get-departments`, undefined, {
      headers: {
        sessionId: localStorage.getItem('sessionId_clappy'),
      },
    })
    .then(({ data }) => data);
